import { Card } from 'antd';
import { CardTitleWithIcon } from '@ohpen/enso-ui';
import { CrudFormCardProps } from '../../firms/interfaces';

export const CrudFormCard = ({ children, icon, title, extra, bodyScroll }: CrudFormCardProps) => {
  return (
    <Card key="firm-card" title={<CardTitleWithIcon icon={icon} title={title} />} variant="outlined" size="small">
      {children}
    </Card>
  );
};
